import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var UnknownShortcutSvg = function UnknownShortcutSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    fillRule: "evenodd",
    d: "M2 0h20a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H8.708A9 9 0 0 0 0 9.223V2a2 2 0 0 1 2-2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    fillRule: "evenodd",
    d: "M20 12A8 8 0 0 0 4.453 9.338q.486.137.946.326a7 7 0 1 1 5.554 9.258 9 9 0 0 1-.156.988Q11.386 20 12 20a8 8 0 0 0 8-8m-7.918 3.004L12 15l-.082.004a.75.75 0 1 0 .164 0m.751-2.647A2.5 2.5 0 1 0 9.5 10a.5.5 0 0 0 1 0l.004-.108a1.5 1.5 0 1 1 1.996 1.523l-.104.04a1.5 1.5 0 0 0-.896 1.375v.67l.005.068a.5.5 0 0 0 .995-.068v-.67l.005-.07a.5.5 0 0 1 .328-.403",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.313 23.583q-1.793 0-3.053-1.245T0 19.295q0-1.27.647-2.288a4.36 4.36 0 0 1 1.725-1.57H0V14h5.39v5.39H3.954v-2.97a2.72 2.72 0 0 0-1.797.934 2.8 2.8 0 0 0-.719 1.917q0 1.201.839 2.038a2.78 2.78 0 0 0 2.037.837z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};
export var UnknownShortcut = function UnknownShortcut(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: UnknownShortcutSvg
  }));
};